import { TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Market } from '../../../app/services/api/orderManagementClient';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  market: Market;
};

const MarketItemRow: FC<Props> = ({ market }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['MarketUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/markets/edit/${market.customerTypeId}`);
  };

  const truncateText = (text: string, maxLength: number = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip 
          title={market.name} 
          placement="top"
        >
          <span>{truncateText(market.name)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={market.instanceName} 
          placement="top"
        >
          <span>{truncateText(market.instanceName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        <Tooltip 
          title={market.timezone} 
          placement="top"
        >
          <span>{truncateText(market.timezone)}</span>
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        {market.timezoneOffset !== undefined ? market.timezoneOffset : '-'}
      </TableCell>
      <TableCell align="center">
        {market.currencyCode}
      </TableCell>
    </TableRow>
  );
};

export default MarketItemRow;
